import { useRef } from 'react';
import { usePublishBottomBar } from '../../hooks/useBottomBar';
import { useOrderedBoards } from '../../hooks/useBoards';
import { useT } from '../../i18n';
import { ofBoard, openCards, useCards } from '../../store/cards';
import { BoardChip } from '../ColumnBar/ColumnBar';
import { BoardTabs, usePickBoard } from './BoardTabs';
import styles from './BoardDock.module.css';

/**
 * The desktop's boards at the bottom, where the phone keeps them: one tab each while they fit,
 * the board's name and its list past that. Only with more than one board.
 */
export function BoardDock() {
  const t = useT();
  const boards = useOrderedBoards();
  const cards = useCards((s) => s.cards);
  const pick = usePickBoard(boards);
  const ref = useRef<HTMLElement>(null);
  usePublishBottomBar(ref);
  const count = (id: string) => openCards(ofBoard(cards, id)).length;
  return (
    <nav ref={ref} className={styles.dock} aria-label={t.t('boards.title')}>
      <div className={styles.inner}>
        <BoardTabs
          size="dock"
          title={t.t('boards.shortcut')}
          fallback={
            <div className={styles.chip}>
              <BoardChip boards={boards} count={count} pick={pick} />
            </div>
          }
        />
      </div>
    </nav>
  );
}
